import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTwitter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="17"
    viewBox="0 0 20 17"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9525 4.23464C17.96 4.41898 17.965 4.60332 17.965 4.79028C17.965 10.4604 13.8375 17 6.29 17C3.9725 17 1.81625 16.2901 0 15.0729C0.32125 15.1121 0.6475 15.1317 0.97875 15.1317C2.90125 15.1317 4.67 14.4467 6.075 13.2949C4.27875 13.2609 2.76375 12.0201 2.24125 10.3153C2.4925 10.365 2.74875 10.3911 3.01375 10.3911C3.3875 10.3911 3.75 10.3388 4.095 10.2408C2.2175 9.84726 0.803749 8.11236 0.803749 6.03361V5.9787C1.35625 6.30031 1.99 6.49381 2.6625 6.51603C1.56125 5.74598 0.836249 4.43205 0.836249 2.94424C0.836249 2.15719 1.03875 1.41983 1.3925 0.785741C3.41625 3.38222 6.44 5.09098 9.85 5.27009C9.78 4.95632 9.74375 4.62816 9.74375 4.29216C9.74375 1.92186 11.5812 0 13.8462 0C15.0275 0 16.0938 0.521649 16.8412 1.35576C17.7762 1.16358 18.655 0.80666 19.4475 0.315081C19.1413 1.31654 18.49 2.15719 17.6438 2.6893C18.4738 2.58471 19.2638 2.35461 20 2.01338C19.45 2.87364 18.7537 3.62932 17.9525 4.23464Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgTwitter;
